/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if( typeof jQuery != 'undefined' ){
jQuery(document).ready(function(){
  setInterval(function () {
    if( !jQuery('.add-to-152252').length ) jQuery('<p class="add-to-152252">If you need more the 1 D-BOX seat, please contact us.</p>').insertAfter('div[data-xpv-attribute-id="152252"]');    
  }, 1000);

  jQuery('<div style="text-align:center;margin-bottom:50px;font-size:20px;"><p style="color:#fff;">Any question?</p><p><a class="expivi-custom-button" style="color:#fff;" href="mailto:jaymar@jaymar.ca">CONTACT US</a></p><p><a style="color:#fff;" href="tel:+19725524043">972-552-4043</a></p></div>').insertAfter('.option-container');
  
});
}


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


if (typeof document.getElementsByClassName('VideoPreview__wrapper')[0] !== 'undefined') {
  const videoContainer = document.getElementsByClassName('VideoPreview__wrapper')[0];
  videoContainer.style.display = "block";

  const playVideo = document.getElementsByClassName('play_video')[0];
  const wrapper = document.getElementsByClassName('ImageHero')[0];
  
  
  var iframe = document.getElementsByClassName('vimeo_header')[0];
  var player = new Vimeo.Player(iframe);
  
  
  playVideo.addEventListener('click', function() { 
    wrapper.classList.toggle("open");
    player.setVolume(1);
    player.setCurrentTime(0);
    player.play();
  });
  
  player.on('pause', function() {
    wrapper.classList.toggle("open");
    player.setVolume(0).then(function() {
      player.setCurrentTime(0);
      player.play();
    });
  });
}

function expiviScreenshot() {
  window.expivi.getScreenshot(1024, 1024).then(function(aScreenshotBase64) {

    // Open in new tab.
    const image = new Image();
    image.src = aScreenshotBase64;

    const w = window.open('_screenshot');
    window.setTimeout(function() {
        w.document.write(image.outerHTML);
    }, 0);
} );
}

var darkmodeSwitch = false;
function darkmodeSwitcher() {
		darkmodeSwitch = !darkmodeSwitch;
		if (darkmodeSwitch) {
			
			window.expivi.setProductAttribute(178903, 427011);
		}
		else {
			window.expivi.setProductAttribute(178903, 427010);
			
		}
		
	}

var measureSwitch = false;
function measureSwitcher() {
		measureSwitch = !measureSwitch;
		if (measureSwitch) {
			
			window.expivi.setProductAttribute(179077, 427544);
		}
		else {
			window.expivi.setProductAttribute(179077, 427545);
			
		}
		
	}

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details

  if(!variant){
    let formData = new FormData(document.querySelector('.ProductForm'));
    let nextVariantId = product.variants.filter((pVariant) => pVariant.options.includes(formData.get('option-0')))[0].id;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('variant', nextVariantId);
    window.location.search = searchParams;
  } else{
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('variant', variant.id);
    window.location.search = searchParams;
  }
});

document.querySelectorAll('.ProductItem__ViewButton').forEach(function(element){
  element.addEventListener('click', function(event){
    // window.dataLayer = window.dataLayer || []; window.dataLayer.push({ "event": "view_item", "product": "{{" + event.currentTarget.dataset.product.title + "}}", "on_sale":"{{" + event.currentTarget.dataset.product.price < event.currentTarget.dataset.product.compare_at_price + "}}"});
  })
})

document.querySelectorAll('.CollectionItem__Link').forEach(function(element){
  element.addEventListener('click', function(event){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "clic-category-cta", "category_name": event.currentTarget.closest(".CollectionItem__Content").querySelector('.SectionHeader__Heading').textContent});
  })
})

document.querySelectorAll('.btn-sample').forEach(function(element){
  element.addEventListener('click', function(event){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "order_sample", "product": product.title});
  })
})


document.querySelectorAll('.Newsletter').forEach(function(element){
  element.addEventListener("submit", (e)=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "subscribe-newsletter", "page": window.location.href});
  });
})